var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"impersonate-button",class:{ 'impersonate-button_disabled': _vm.isLoading },on:{"click":_vm.stopImpersonating}},[_vm._v(_vm._s(_vm.$t("header.stop_impersonating")))])}
var staticRenderFns = []

export { render, staticRenderFns }